//Library imports
import { Outlet } from "react-router-dom";

//Design imports
import "../style.css";

export default function Main() {
	return (
		<>
			<Outlet />
		</>
	);
}
